"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShortcutBase_1 = require("./ShortcutBase");

var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");

var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");

var PortfoliosMptStatisticsShortcut =
/** @class */
function (_super) {
  __extends(PortfoliosMptStatisticsShortcut, _super);

  function PortfoliosMptStatisticsShortcut(scenarioStatisticQuery) {
    return _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.entityRisksTable, shortcuts_1.ShortcutType.directResponse, scenarioStatisticQuery) || this;
  }

  PortfoliosMptStatisticsShortcut.prototype.getDirectResponse = function (shortcutOptions, scenarioStatistics) {
    var _this = this;

    var response = [];
    var options = shortcutOptions && shortcutOptions.options && shortcutOptions.options.portfoliosMptStatistics || {};
    var portfolioKeyTransform = options.portfolioKeyTransform,
        _a = options.excludeBenchmark,
        excludeBenchmark = _a === void 0 ? false : _a,
        _b = options.fields,
        fields = _b === void 0 ? [] : _b;
    var periodType = this.scenarioStatisticQuery.getSinglePeriodType(shortcutOptions.periods);

    if (periodType) {
      var _c = scenarioStatistics.periods,
          periods = _c === void 0 ? [] : _c;
      var period = periods.find(function (period) {
        return period.periodType === periodType;
      });

      if (period) {
        var _d = period.portfolios,
            portfolios = _d === void 0 ? [] : _d,
            benchmark = period.benchmark;

        var allPortfolios_1 = __spreadArrays(portfolios);

        if (!excludeBenchmark && benchmark) {
          allPortfolios_1.push(benchmark);
        }

        fields.forEach(function (field) {
          var name = field.name,
              key = field.key,
              queryOptions = field.query;
          var row = {
            key: key,
            name: name
          };
          allPortfolios_1.forEach(function (portfolioResult) {
            var portfolio = portfolioResult && portfolioResult.portfolio;

            if (portfolio) {
              var key_1 = _this.scenarioStatisticQuery.applyValueTransform(portfolioResult.id, portfolioKeyTransform);

              var value = _this.scenarioStatisticQuery.getValueForPortfolio(portfolio, queryOptions);

              row[key_1] = value;
            }
          });
          response.push(row);
        });
      }
    }

    return response;
  };

  return PortfoliosMptStatisticsShortcut;
}(ShortcutBase_1.ShortcutBase);

exports.PortfoliosMptStatisticsShortcut = PortfoliosMptStatisticsShortcut;